<template>
  <div
    class="pagoda-drop-down"
    :class="[dropDownClass]"
    :style="{
      left: `${left}px`,
      top: `${top}px`
    }"
    v-show="isShow"
    @click="handleClick"
  >
    <slot></slot>
  </div>
</template>

<script>
let dropDownInstances = []
let seed = 0

const handleBodyClick = function () {
  dropDownInstances.forEach((instance) => instance.hide())
}

document.body.addEventListener('click', handleBodyClick, false)

export default {
  name: 'DropDown',
  props: {
    dropDownClass: {
      type: String,
      default: ''
    },
    hideOnClick: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      left: 0,
      top: 0,
      isShow: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.seed = `pagoda_drop_down_${seed++}`
      this.$el.parentNode.removeChild(this.$el)
      document.body.appendChild(this.$el)

      dropDownInstances.push(this)
    })
  },
  methods: {
    handleClick(e) {
      if (e.target === this.$el) {
        e.stopPropagation()
      } else if (!this.hideOnClick) {
        e.stopPropagation()
      }
    },
    show({ left, top }) {
      this.left = left
      this.top = top

      this.isShow = true
    },
    hide() {
      this.isShow = false
    }
  },
  beforeDestroy() {
    dropDownInstances = dropDownInstances.filter((instance) => instance.seed !== this.seed)
    document.body.removeChild(this.$el)
  }
}
</script>
